import { Component, OnInit } from '@angular/core';
import { ForuscareService } from '../services/foruscare/foruscare.service';
import { Device } from '../models/device';
import { AccountService } from '../services/account/account.service';
import { DeviceService } from '../services/device/device.service';
import { Account } from '../models/account';
import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { CommonModule } from '@angular/common';
import { UserService } from '../services/user/user.service';

@Component({
  selector: 'app-device',
  templateUrl: './device.component.html',
  styleUrls: ['./device.component.css']
})
export class DeviceComponent implements OnInit {

  device: any = {}; devices: any[] = []; accounts: any[]=[]; totalRecords: number = 0; listing: boolean = true; isDeviceAssigned = false;
  screeningCenters: any[] = []; assignWindow = false; assignAction = null;deviceModelList:any[] = [];deviceCategoryList:any[] = [];
  public paging = {currentPage:  0};// Pagination starting index
  rows = 10; // Rows per page
  
  constructor(public foruscareService: ForuscareService, public accountService: AccountService, public deviceService: DeviceService, public userService: UserService) {
  this.setupSearch();
   }
  private searchTerms = new Subject<any[]>();  // Subject to emit search terms
  results: any[] = [];  // Store search results
  saveDevice() {
    if (this.device != null) {
      if (this.device.deviceCategoryId == null ) {
        this.foruscareService.showNotification("Please select a device category.", "danger");
        return;
      }
      if (this.device.manufacturer == null || this.device.manufacturer.trim().length == 0) {
        this.foruscareService.showNotification("Please enter device manufacturer.", "danger");
        return;
      }
      if (this.device.manufacturer != null && this.device.manufacturer.toLowerCase().indexOf("forus") < 0) {
        if (this.device.dataPath == null || this.device.dataPath.trim().length == 0) {
          this.foruscareService.showNotification("Please enter data path.", "danger");
          return;
        }
      }
      
      if (this.device.orgId != null && typeof this.device.orgId == "object") {
        this.device.orgId = this.device.orgId.orgId;
      }
      if (this.device.accountId != null && typeof this.device.accountId == "object") {
        this.device.accountId = this.device.accountId.accountId;
      }
      if (this.device.deviceId == null) {
        this.deviceService.addDevice(this.device)
          .subscribe(response => {
            if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
              if (response.data != null) {
                this.foruscareService.showNotification("device saved successfully.", "success");
                this.toggleView();
                console.log("this aberro device "+response.data);
                this.devices.push(this.device);
              }
            } else if( response.errorCode == 409 ){
              this.foruscareService.showNotification("The device serial number ("+this.device.serialNumber+") already exists", "error");
            } else {
              this.foruscareService.showNotification(response.message, "error");
            }
          });
      }
      else {
        this.deviceService.updateDevice(this.device, this.device.deviceId)
          .subscribe(response => {
            if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
              if (response.data != null) {
                this.toggleView();
                this.foruscareService.showNotification("device updated successfully.", "success");
              }
            }
            else {
              this.foruscareService.showNotification(response.message, "danger");
            }
          });
      }
    }
  }

  onDeviceCategoryChange(event) {
    if ( event != null ) {
      this.device.orgId = null;
      // this.device.deviceCategoryName = this.deviceCategoryList.find(ob => event == ob.deviceCategoryId).deviceCategoryName;
      this.device.deviceCategoryName = this.deviceCategoryList.find(ob => ob.id == event).name;
      this.getScreeningCentersByAccountID(this.device.accountId,this.device.deviceCategoryName);
    }
  }

  updateScreeningCenters(event) {
    if (event != null && event.value != null) {
      this.device.orgId = null;
      this.getScreeningCentersByAccountID(event.value,this.device.deviceCategoryName);
    }
  }

  getScreeningCentersByAccountID(account,deviceCategoryName) {
    if (account != null && account.accountId != null  && deviceCategoryName != null ) {
      let payload = {"accountId":account.accountId,"deviceCategoryName":deviceCategoryName};
      this.screeningCenters = [];
      this.accountService.screeningCentersByAccountAndDeviceCategory(payload)
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {
              this.screeningCenters = response.data;
              this.screeningCenters = this.screeningCenters.filter(ob => ob.deviceId == null || ob.orgId == this.device.orgId);
            }
          } else if ( response.errorCode == 204 ) {
            this.foruscareService.showNotification("No Screening centers found", "danger");
          } else if ( response.errorCode == 226 ) {
            this.foruscareService.showNotification("All available Screening centers are already tagged for the selected device category - "+deviceCategoryName+" and account -"+account.name , "danger");
          } else {
            this.foruscareService.showNotification(response.message, "danger");
          }
          if (this.device.orgId != null) {
            this.device.orgId= parseInt(this.device.orgId);
            this.screeningCenters.push({ 'orgId' : this.device.orgId, 'orgName' : this.device.orgName });
            this.screeningCenters = this.screeningCenters.filter(ob => ob.deviceId == null || ob.orgId == this.device.orgId);
            this.device.orgId = this.screeningCenters.find(ob => ob.orgId == this.device.orgId);
          }
        });
    } else {
      if( this.device.accountId == null ) {
        this.foruscareService.showNotification("Please select account", "danger");
      } else if( this.device.deviceCategoryId == null  ) {
        this.foruscareService.showNotification("Please select device category", "danger");
      }
    }
  }

  unAssignDevice() {
    this.device.accountId = null;
    this.device.orgId = null;
    this.deviceService.updateDevice(this.device, this.device.deviceId)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            this.assignWindow = false;
            this.getAllDevices(0);
            this.foruscareService.showNotification("device unassigned successfully.", "success");
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  assignDevice() {
    if (this.device != null) {
      if (this.device.orgId != null && typeof this.device.orgId == "object") {
        this.device.orgId = this.device.orgId.orgId;
      }
      if (this.device.accountId != null && typeof this.device.accountId == "object") {
        this.device.accountId = this.device.accountId.id;
      }
      this.deviceService.updateDevice(this.device, this.device.deviceId)
        .subscribe(response => {
          if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
            if (response.data != null) {
              this.assignWindow = false;
              this.getAllDevices(0);
              this.foruscareService.showNotification("device assigned successfully.", "success");
            }
          }
          else {
            this.foruscareService.showNotification(response.message, "danger");
          }
        });
    }
  }

  viewConfirmWindow(action: string, deviceinfo: Device) {
    console.log(this.accounts)
    if (action != null) {
      if( action === "assign" ) {
        deviceinfo.accountId = null;
        deviceinfo.orgId = null;
      }
      this.assignAction = action;
      this.device = deviceinfo;
      this.assignWindow = true;
    }
  }

  closeConfirmWindow(){
    this.assignWindow = false;
    if( this.assignAction == "assign" ) {
      this.device.accountId = null;
      this.device.orgId = null;
    }
  }

  updateDeviceStatus(deviceInfo: Device) {
    this.deviceService.updateDevice(deviceInfo, deviceInfo.deviceId)
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            this.assignWindow = false;
            this.foruscareService.showNotification("device status updated successfully.", "success");
            this.getAllDevices(0);
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  editDeviceInfo(deviceinfo: Device) {
    if (deviceinfo != null) {
      this.screeningCenters = [];
      this.device = deviceinfo;
      if (this.device.accountId != null) {
        this.device.accountId = this.accounts.find(ob => ob.accountId == this.device.accountId);
        this.getScreeningCentersByAccountID(deviceinfo.accountId,this.device.deviceCategoryName);
      }
      if (this.device.orgId != null) {
        this.isDeviceAssigned = true;
      }
      else {
        this.isDeviceAssigned = false;
      }
      this.listing = false;
    }
  }
  offset = 0;
  onPageChange(event) {
    this.offset = event.first;
    this.rows = event.rows;
    this.paging.currentPage = event.first; 
    this.getAllDevices(this.offset);
  }

  getAllDevices(offset) {
    let count = 10;
    this.devices = [];
    this.userService.devicesSearch(this.userSearchTerms.term,this.userSearchTerms.searchby,count, offset)
      .subscribe(response => {
        if (response.status == 200) {
          if (response.data != null) {
            this.devices = response.data.response;
            this.totalRecords = response.data.totalCount;
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  getAccountName(accountId) {
    let account = this.accounts.find(ob => ob.id == accountId);
    if (account != null)
      return account.name;
    else return "";
  }

  getAvailableAccounts() {
    this.accounts = [];
    this.accountService.getExistingAccounts()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            this.accounts = response.data;
            //this.getAllDevices(0);
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }

  getDeviceCategoryList() {
    this.accounts = [];
    this.accountService.getDeviceCategories()
      .subscribe(response => {
        if (response.errorCode == 200 && response.status == this.foruscareService.RESULT_SUCCESS) {
          if (response.data != null) {
            
            response.data.forEach(element => {
              if( element != null && element.id != null ) {
                element.id = parseInt(element.id); 
              }
              
            });
            this.deviceCategoryList = response.data;
            this.deviceCategoryList.unshift({"id":null,"name":"Select Device Category","description":null});
           // this.getAllDevices(0);
          }
        }
        else {
          this.foruscareService.showNotification(response.message, "danger");
        }
      });
  }


  ngOnInit() {
    this.deviceModelList=[{"name":"Select Device","value":null},{"name":"Classic","value":"CLASSIC"},{"name":"Classic HD","value":"CLASSIC_HD"},{"name":"Classic 6.4","value":"CLASSIC_6.4"},{"name":"Classic Plus","value":"CLASSIC_PLUS"},{"name":"Ultima","value":"ULTIMA"},{"name":"Neo","value":"NEO"},{"name":"Neo HD","value":"NEO_HD"},{"name":"Aberro","value":"Aberro"},{"name":"Pico","value":"PICO"},{"name":"Specto","value":"SPECTO"}];
    // this.deviceCategoryList=[{"id":null,"name":"Select Device Category","value":null},{"id":1,  "name":"Fundus","value":"Fundus"},{"id":2,  "name":"Refraction","value":"Refraction"}];
    this.getAvailableAccounts();
    this.getDeviceCategoryList();
  }
  

  toggleView() {
    this.listing = !this.listing;
    this.device = new Device();
    this.isDeviceAssigned = false;
    if (this.listing) { 
      this.userSearchTerms.term = "";
      this.userSearchTerms.searchby = "";
      this.getAllDevices(0); 
    } else {
      if( this.deviceCategoryList.length == 0 ) {
        this.getDeviceCategoryList();
      }
      
    };
  }
  setupSearch(): void {
    this.devices = [];
    let count = 10;
    //let offset = 0;
    this.searchTerms.pipe(
      debounceTime(300),                // Wait for 300ms after the user stops typing
      distinctUntilChanged(),           // Only call the API if the term has changed

      switchMap((term: any) => this.userService.devicesSearch(term[0], term[1], count, this.offset))  // Switch to the new search term
    ).subscribe(response => {
        if (response.data != null && response.data.response.length > 0) {
          this.devices = response.data.response;
          this.totalRecords = response.data.totalCount;
        }else{
          this.devices = [];
        }
            // Update the results after the API call
    });
  }
  userSearchTerms = {
    term: '',
    searchby: ''
  }
  // Method triggered when typing in the search box
  onSearch(term: string, searchby:string): void {
    this.offset = 0;
    this.devices = [];
    this.paging.currentPage = 0;
    if(searchby == 'devicemodel'){
      let query = term.toLowerCase();
        if (query === 'classic hd' || query === 'neo hd' || query === 'classic 6.4' || query === 'classic 40' || query === 'classic plus') {
          term = query.replace(/\s+/g, '_');
        }
    }

    this.userSearchTerms = {
      term: term,
      searchby: searchby
    }

    this.searchTerms.next([term,searchby]);  // Push the search term into the observable stream
  }

}
